<template>
  <div class="editor-container" :class="product.attribute_values.photoLayout.slug" id="photo">
    <div class="fixed">
      <EditorMenu />
      <GlassPreview />
    </div>
    <div class="product-fields">
      <!-- Sold -->
      <SoldCapacity v-if="soldCapacity"/>
      <!-- Editor -->
      <div class="form-fields">
        <ImageHandler v-for="n in layoutPhotoCount" :number="n" />
        <PhotoFields />
        <GlobalAttributes type="photo" />
        <AddToCart />
      </div>
      <Loader />
    </div>
  </div>
</template>
<script>
import { optional } from "../../../../helpers";
import { mapGetters } from "vuex";
import AddToCart from "./AddToCart";
import usePhoto from "../usePhoto";
import ImageHandler from "./photo/ImageHandler";
import ProductServices from "./../../../packages/views/product-service/Services";
import Loader from "../../../packages/views/loader/Loader";
import PhotoFields from "./photo/PhotoFields";
import GlobalAttributes from "./attributes/GlobalAttributes";
import GlassPreview from "./glass-preview/Photo";
import EditorMenu from "./EditorMenu.vue";
import SoldCapacity from "./SoldCapacity.vue";

export default {
  components: {
    PhotoFields,
    ProductServices,
    Loader,
    ImageHandler,
    AddToCart,
    GlobalAttributes,
    GlassPreview,
    EditorMenu,
    SoldCapacity,
  },
  computed: {
    ...mapGetters({
      product: "product/getProduct",
      soldCapacity: 'product/getSoldCapacity'
    }),
  },
  setup() {
    const { layoutPhotoCount } = usePhoto();

    return {
      layoutPhotoCount,
      optional,
    };
  },
};
</script>
